
import { useState,useEffect } from "react";


import input_check from "../input_check.png";
import input_error from "../input_error.png";


function InputPhone(props)
{
 

    var tmp = props.value;
    tmp = tmp.replace(' ','');

    const [val, setVal] = useState(tmp);
    const [req, setRequired] = useState(props.req);
    const [cn, setClassName] = useState('');

    const [onShow,setOnShow] = useState(false);


    const validate = (vx) => {
        return false;
      };


    const checkAndChange = (e) =>
    {
        var v = e.target.value;

        if(  v.indexOf("+48") !== -1 )
        {
          
        }else
        {
            v = "+48" + v;
        }

         v = v.replace(/[^0-9]/g, ''); 
         v = "+" + v;

         if(v == '+48') v = '';
         

        setVal(v);

        var correct = true;

       
        var cV = v.replace(" ","");
        if  (!( cV.length > 0 &&  (cV.length == 9 || cV.length == 12)  )) correct = false;
                 
        if( v.length == 0 && req != '1' ) correct = true; 
        if( v.length < 9 && req == '1' ) correct = false; 
     
        
 
        
                        
        
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }

        if(props.valChange != null && props.valChange != undefined)
        {
            props.valChange(props.name, v, correct,'');
        }else
        {
            console.log('No support for valChange');
        }    
    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
               if(props.goNext != null && props.goNext != undefined)
               {
                  props.goNext();
               }
          } 
    }


    if(cn.length < 2)
    {
        var correct = true;
        
        if(req == '1' &&  val != undefined ) 
        {
            if(val.length != 9 && val.length != 12) correct = false;         
        }
    
 
      
      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }
    }

    var imgx = null;

    if(cn == "incorrent" && req=='1')
    {
        imgx = <img  className="input_status" src={input_error} />
    }

    
    if(cn == "corrent" && req=='1')
    {
        imgx = <img className="input_status" src={input_check} />
    }

    
    useEffect(() => {

        if(val != props.value) //aktualizuj jesli sie zmieni..
        {
            setVal(props.value);
            setOnShow(false);
        }

        if( onShow == false && props.valChange != null && props.valChange != undefined ) //sprawdz czy dane sa poprawne i wyslij wyzej
        {
             var correct = true;
             if(cn == "incorrent" ) correct = false;                 
             setOnShow(true);
             props.valChange(props.name, val, correct,'');
    
        }
    })

     

    var tmp = "";

    if(val != undefined &&  val.length == 12)
    {
    tmp += val.charAt(0);
    tmp += val.charAt(1);
    tmp += val.charAt(2);
    tmp += " ";
    tmp += val.charAt(3);
    tmp += val.charAt(4);
    tmp += val.charAt(5);
    tmp += " ";
    tmp += val.charAt(6);
    tmp += val.charAt(7);
    tmp += val.charAt(8);
    tmp += " ";
    tmp += val.charAt(9);
    tmp += val.charAt(10);
    tmp += val.charAt(11);
    }else tmp = val;




    var err = "";
    if(props.err != undefined  &&  props.err != null ) 
    {       
        if(props.err[props.name] != null  && props.err[props.name] != undefined    ) err = props.err[props.name]['param'];
    } 



    var cnX = cn;
    if( val!=null &&  val.length < 1 && cnX == 'corrent')
    {
            cnX = '';
    }

    var defC = " w150 ";

    if(props.className != undefined)   
    {
        cnX = cnX + " " + props.className;
        defC = "";
    }


 



    return <fieldset>        
        <input type="phone"  value={tmp} onChange={checkAndChange} onKeyDown={onKeyDown} name={props.name} placeholder={props.placeholder} className={ defC +  "  " + cnX} />        
        {imgx}
        <br/>
             <span className="form_err">{err + " "} &nbsp; </span>        
    </fieldset>
}


export default InputPhone;